import React from "react";
import { useDispatch } from "react-redux";

//import MUI
import { Modal } from "antd";

// import APIs
import CreateApi from "../../api/customer/ticket/Create";

// redux
import { setMetaData } from "../../redux/reducers/page";
import { setAuth } from "../../redux/reducers/customer";

// form elements

import TextField from "../formElement/TextField";
import TextArea from "../formElement/TextArea";
import Autocomplete from "../formElement/Autocomplete";

import FileUploader from "../../layout/common/FileUploader";

import departments from "../../eNums/departments.enum";
import { ErrorNotify, SuccessNotify } from "../../ui/Toast";
const departmentsOpt = Object.keys(departments).map((item) => {
  return {
    value: departments[item].code,
    label: departments[item].text,
  };
});
const priorityOpt = [
  {
    value: 1,
    label: "زیاد",
  },
  {
    value: 2,
    label: "متوسط",
  },
  {
    value: 3,
    label: "کم",
  },
];
const CreateTicket = (props) => {
  const dispatch = useDispatch();

  const [sending, setSending] = React.useState(false);
  const [medias, setMedias] = React.useState([]);
  const [subject, setSubject] = React.useState(null);
  const [ticketDeparmentId, setTicketDeparmentId] = React.useState(null);
  const [priority, setPriority] = React.useState(null);
  const [text, setText] = React.useState(null);
  const { openModal, setOpenModal, auth, findtickets } = props;

  const submitForm = async () => {
    if (subject === null) {
      ErrorNotify(" موضوع درخواست وارد نشده ");
      return;
    }
    if (text === null) {
      ErrorNotify(" متن درخواست وارد نشده ");
      return;
    }
    if (ticketDeparmentId === null) {
      ErrorNotify("  بخش مور نظر را انتخاب نشده  ");
      return;
    }
    if (priority === null) {
      ErrorNotify(" اولویت انتخاب نشده ");
      return;
    }

    setSending(true);
    const result = await CreateApi(
      auth.token,
      subject,
      ticketDeparmentId,
      priority,
      text,
      medias.map((media, index) => {
        return { mediaId: media.id, title: `پیوست ${index + 1}` };
      })
    );
    if (result.status === 403) {
      dispatch(
        setAuth({
          token: null,
          customer: null,
          isAuthenticated: false,
          newBasket: null,
        })
      );
      return;
    }
    if (result.status === 400) {
      ErrorNotify(" مقادیر به درستی وارد نشده است ");
      setSending(false);
      return;
    }
    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      setSending(false);
      return;
    }
    if (result.status === 200) {
      SuccessNotify("درخواست پشتیبانی با موفقیت ثبت شد");
      findtickets();
      setMedias(null);
      setSubject(null);
      setTicketDeparmentId(null);
      setPriority(null);
      setText(null);
      setSending(false);
      setOpenModal(false);
      return;
    }
  };
  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت :    درخواست پشتیبانی جدید",
        description: "میشرت:   درخواست پشتیبانی جدید",
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal
      title="درخواست پشتیبانی جدید"
      centered
      open={openModal}
      onOk={() => submitForm()}
      okButtonProps={{ disabled: sending }}
      onCancel={() => setOpenModal(false)}
      okText={"تایید"}
      cancelText="انصراف"
    >
      <div className="col-12">
        <hr className="p-0 m-1" />
        <div className="row">
          <div className="col-12 p-0 ">
            <TextField
              required={true}
              name="subject"
              label="موضوع"
              type="text"
              onChange={(e) => setSubject(e.target.value)}
            />
          </div>
          <div className="col-6 pl-1  pr-0 ">
            <Autocomplete
              options={departmentsOpt}
              defaultValue={null}
              name="department"
              label="بخش مورد نظر "
              setValue={setTicketDeparmentId}
            />
          </div>
          <div className="col-6 pl-1  pr-0 ">
            <Autocomplete
              options={priorityOpt}
              defaultValue={null}
              name="priority"
              label=" اولویت "
              setValue={setPriority}
            />
          </div>

          <div className="col-12 p-0 ">
            <TextArea
              required={true}
              name="text"
              label="متن درخواست  "
              type="text"
              multiline={true}
              rows={5}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
          <div className="col-12 p-0 ">
            <FileUploader
              token={auth.token}
              dist={"tickets"}
              setUploadedFiles={setMedias}
              uploadedFiles={medias}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default CreateTicket;
